<template>
  <div class="contenedor-lista-pagos">
    <form
      action="#"
      method="post"
      @submit.prevent="buscarImpago(pago)"
    >
      <div class="form_section">
        <label for="servicio_id">Servicio</label>
        <select
          id="servicio_id"
          name="servicio_id"
          class="form minimal"
          v-model.number="pago.servicio_id"
          :disabled="cargando"
        >
          <option value="null">Todas las opciones</option>
          <option
            v-for="servicio in servicios"
            :value="servicio.servicio_id"
            :key="servicio.servicio_id"
          >
            {{ servicio.nombre }}
          </option>
        </select>
      </div>
      <button type="submit" class="boton_guardar">Buscar</button>
    </form>
    <div class="contenedor_tablas_impago" v-if="mostrarTablasImpago">
      <button
        class="boton_exportar"
        @click="exportData"
      >
        Exportar a Excel
      </button>
      <div class="tabla_impago">
        <h2>Falta Cobrar - {{ nombreServicio }}</h2>
        <table id="tabla-socio-lista">
          <thead>
            <th>Nombre</th>
            <th>Email</th>
            <th>Perfil</th>
            <th>Cuota</th>
          </thead>
          <tbody>
            <ServiciosImpagosListaItem
              v-for="persona in personasNoPagas"
              :persona="persona"
              :key="persona.persona_id.cuota_id"
            ></ServiciosImpagosListaItem>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store'
import ServiciosImpagosListaItem from '../components/ServiciosImpagosListaItem.vue'
// import SeviciosPagosListaItem from '../components/SeviciosPagosListaItem.vue'
import pagosService from '../services/pagos'
import serviciosService from '../services/servicios'
const XLSX = require('xlsx')
export default {
  name: 'ServiciosImpagosLista',
  components: {
    ServiciosImpagosListaItem
    // SeviciosPagosListaItem
  },
  data: function () {
    return {
      personasPagas: [],
      personasNoPagas: [],
      servicios: [],
      archivo: [],
      cargando: false,
      nombreServicio: null,
      mostrarTablasImpago: false,
      pago: {
        servicio_id: null
        // persona_id: null,
        // concepto_id: null,
        // fecha_inicio: null,
        // mercadopago_id: null,
        // fecha_finalizacion: null
      },
      user: {
        tipo_id: JSON.parse(localStorage.getItem('userData')).tipo_id,
        persona_id: JSON.parse(localStorage.getItem('userData')).persona_id,
        nombre: JSON.parse(localStorage.getItem('userData')).nombre,
        apellido: JSON.parse(localStorage.getItem('userData')).apellido,
        dni: JSON.parse(localStorage.getItem('userData')).dni,
        direccion: JSON.parse(localStorage.getItem('userData')).direccion_1,
        provincia: JSON.parse(localStorage.getItem('userData')).provincia_id_1
      },
      errores: {
        fecha_inicio: null,
        fecha_finalizacion: null
      },
      store
    }
  },
  methods: {
    fechaFormato (fecha) {
      const year = fecha.slice(0, 4)
      const month = fecha.slice(5, 7)
      const day = fecha.slice(8, 10)
      return day + '/' + month + '/' + year
    },
    nextPage () {
      this.currentPage++
      console.log(this.currentPage)
      this.sosUltimaPagina()
      console.log(this.paginado)
    },
    prevPage () {
      this.currentPage--
      console.log(this.currentPage)
      this.sosUltimaPagina()
      console.log(this.paginado)
    },
    goToPage (page) {
      this.currentPage = page
      console.log(page)
      this.sosUltimaPagina()
      console.log(this.paginado)
    },
    firstPage () {
      this.currentPage = 1
      this.sosUltimaPagina()
      console.log(this.paginado)
    },
    lastPage () {
      this.currentPage = this.pageCount
      this.sosUltimaPagina()
      console.log(this.paginado)
    },
    sosUltimaPagina () {
      console.log('2222222')
      const start = Math.floor((this.currentPage - 1) / this.sizeBulletPaginado) * this.sizeBulletPaginado
      // const end = start + this.sizeBulletPaginado
      if (this.pageCount - start < this.sizeBulletPaginado) {
        this.mostrarLastPageBullets = false
      } else {
        this.mostrarLastPageBullets = true
      }
    },
    exportData () {
      const data = this.archivo
      // const data = [{ foo: 'foo' }, { bar: 'bar' }]
      // const fileName = 'Listado_de_Pagos'
      // const exportType = 'csv'
      // exportFromJSON({ data, fileName, exportType })
      // exportFromJSON({ data, exportType })
      const workSheet = XLSX.utils.json_to_sheet(data)
      const workBook = XLSX.utils.book_new()
      // XLSX.utils.book_append_sheet(workBook, workSheet, 'Impagos')
      XLSX.utils.book_append_sheet(workBook, workSheet, 'Impagos - ' + this.nombreServicio)
      XLSX.writeFile(workBook, 'Impagos.xlsx')
    },
    // borrarNotificacion () {
    //   this.store.setStatus({
    //     msg: null,
    //     type: null,
    //     title: null
    //   })
    // },
    // refrescarPagos () {
    //   pagosService
    //     .traerPagosTodos()
    //     .then(respuesta => {
    //       // this.cargando = false
    //       this.pagos = respuesta
    //       console.log('Todas los pagos', respuesta)
    //     })
    // },
    buscarImpago (pago) {
      this.cargando = true
      this.errores = {
        fecha_inicio: null,
        fecha_finalizacion: null
      }
      console.log(pago)
      pagosService
        .buscarImpago(pago)
        .then(respuesta => {
          this.cargando = false
          console.log(respuesta)
          if (respuesta.success) {
            // this.personasPagas = respuesta.data[0].pago
            // for (var i = 0; i < respuesta.data[0].pago.length; i++) {
            //   this.personasPagas(...respuesta.data[0].pago[i])
            // }
            // this.personasPagas.push(respuesta.data[0].pago.cuota_1, respuesta.data[0].pago.cuota_2)
            // this.personasPagas = [...respuesta.data[0].pago.cuota_1, ...respuesta.data[0].pago.cuota_2, ...respuesta.data[0].pago.cuota_3]
            // ESTO FUNCIONA
            this.mostrarTablasImpago = true
            this.nombreServicio = respuesta.data[1].no_pago.cuota_1[0].servicio
            this.personasPagas = respuesta.data[0].pago.cuota_1
            switch (Object.keys(respuesta.data[0].pago).length) {
              case 2:
                this.personasPagas = this.personasPagas.concat(respuesta.data[0].pago.cuota_2)
                break
              case 3:
                this.personasPagas = this.personasPagas.concat(respuesta.data[0].pago.cuota_2)
                this.personasPagas = this.personasPagas.concat(respuesta.data[0].pago.cuota_3)
                break
              case 4:
                this.personasPagas = this.personasPagas.concat(respuesta.data[0].pago.cuota_2)
                this.personasPagas = this.personasPagas.concat(respuesta.data[0].pago.cuota_3)
                this.personasPagas = this.personasPagas.concat(respuesta.data[0].pago.cuota_4)
                break
              case 5:
                this.personasPagas = this.personasPagas.concat(respuesta.data[0].pago.cuota_2)
                this.personasPagas = this.personasPagas.concat(respuesta.data[0].pago.cuota_3)
                this.personasPagas = this.personasPagas.concat(respuesta.data[0].pago.cuota_4)
                this.personasPagas = this.personasPagas.concat(respuesta.data[0].pago.cuota_5)
                break
              case 6:
                this.personasPagas = this.personasPagas.concat(respuesta.data[0].pago.cuota_2)
                this.personasPagas = this.personasPagas.concat(respuesta.data[0].pago.cuota_3)
                this.personasPagas = this.personasPagas.concat(respuesta.data[0].pago.cuota_4)
                this.personasPagas = this.personasPagas.concat(respuesta.data[0].pago.cuota_5)
                this.personasPagas = this.personasPagas.concat(respuesta.data[0].pago.cuota_6)
                break
            }
            console.log('FINAL PAGO: ', this.personasPagas)
            this.personasNoPagas = respuesta.data[1].no_pago.cuota_1
            switch (Object.keys(respuesta.data[1].no_pago).length) {
              case 2:
                this.personasNoPagas = this.personasNoPagas.concat(respuesta.data[1].no_pago.cuota_2)
                break
              case 3:
                this.personasNoPagas = this.personasNoPagas.concat(respuesta.data[1].no_pago.cuota_2)
                this.personasNoPagas = this.personasNoPagas.concat(respuesta.data[1].no_pago.cuota_3)
                break
              case 4:
                this.personasNoPagas = this.personasNoPagas.concat(respuesta.data[1].no_pago.cuota_2)
                this.personasNoPagas = this.personasNoPagas.concat(respuesta.data[1].no_pago.cuota_3)
                this.personasNoPagas = this.personasNoPagas.concat(respuesta.data[1].no_pago.cuota_4)
                break
              case 5:
                this.personasNoPagas = this.personasNoPagas.concat(respuesta.data[1].no_pago.cuota_2)
                this.personasNoPagas = this.personasNoPagas.concat(respuesta.data[1].no_pago.cuota_3)
                this.personasNoPagas = this.personasNoPagas.concat(respuesta.data[1].no_pago.cuota_4)
                this.personasNoPagas = this.personasNoPagas.concat(respuesta.data[1].no_pago.cuota_5)
                break
              case 6:
                this.personasNoPagas = this.personasNoPagas.concat(respuesta.data[1].no_pago.cuota_2)
                this.personasNoPagas = this.personasNoPagas.concat(respuesta.data[1].no_pago.cuota_3)
                this.personasNoPagas = this.personasNoPagas.concat(respuesta.data[1].no_pago.cuota_4)
                this.personasNoPagas = this.personasNoPagas.concat(respuesta.data[1].no_pago.cuota_5)
                this.personasNoPagas = this.personasNoPagas.concat(respuesta.data[1].no_pago.cuota_6)
                break
            }
            console.log('FINAL NO PAGO: ', this.personasNoPagas)
            this.pago.servicio_id = null
            // this.exportarExcel(respuesta)
            // console.log('Busqueda: ', respuesta.data[0].pago)
            this.exportarExcel(this.personasNoPagas)
          } else {
            console.log('Algo salio mal')
          }
        })
    },
    exportarExcel (data) {
      console.log('data: ', data)
      this.archivo = []
      for (var j = 0; j < data.length; j++) {
        const obj = {}
        obj.Persona = data[j].nombre + ' ' + data[j].apellido
        obj.Email = data[j].email
        obj.Perfil = data[j].perfil
        obj.Cuota_Numero = data[j].cuota_numero_nombre
        this.archivo.push(obj)
      }
      console.log('ARCHIVO: ', this.archivo)
    }
  },
  computed: {
    pagosPaginado: function () {
      const start = (this.currentPage - 1) * this.sizePaginado
      const end = start + this.sizePaginado
      return this.pagos.slice(start, end)
    },
    bulletsPaginado: function () {
      const start = Math.floor((this.currentPage - 1) / this.sizeBulletPaginado) * this.sizeBulletPaginado
      const end = start + this.sizeBulletPaginado
      if (this.pageCount - start < this.sizeBulletPaginado) {
        return this.paginado.slice(this.pageCount - this.sizeBulletPaginado, this.pageCount)
      } else {
        return this.paginado.slice(start, end)
      }
    }
  },
  mounted: function () {
    this.cargando = true
    // pagosService
    //   .traerConceptosDePago()
    //   .then(respuesta => {
    //     // this.cargando = false
    //     this.conceptos = respuesta
    //     console.log('Conceptos: ', respuesta)
    //   })
    serviciosService
      .traerServiciosCuotaRegalia()
      .then(respuesta => {
        this.cargando = false
        this.servicios = respuesta
        console.log('Servicios: ', respuesta)
      })
    // pagosService
    //   .traerPagosTodos()
    //   .then(respuesta => {
    //     this.cargando = false
    //     this.pagos = respuesta
    //     console.log('Todas los pagos', respuesta)
    //     this.pageCount = Math.ceil(this.pagos.length / this.sizePaginado)
    //     this.exportarExcel(respuesta)
    //     for (var i = 1; i <= this.pageCount; i++) {
    //       this.paginado.push(i)
    //     }
    //   })
    // asociadoService
      // .listadoPersonasNoExtranjeros()
      // .then(respuesta => {
      //   // this.cargando = false
      //   this.socios = respuesta
      //   console.log('Personas: ', respuesta)
      //   this.socios.map(function (x) {
      //     // const pepe = x.nombre + ' ' + x.apellido
      //     // console.log(pepe)
      //     x.item_data = x.nombre + ' ' + x.apellido
      //     // return x.item_data = pepe
      //   })
      // })
  }
}
</script>
